import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const MaterialTypeList = Loadable(
  lazy(() => import("features/materialtype/components/List"))
);
const MaterialTypePage = Loadable(
  lazy(() => import("features/materialtype/components/Page"))
);

const routes = {
  path: "materialType",
  children: [
    { path: "", element: <MaterialTypeList /> },
    { path: "add", element: <MaterialTypePage /> },
    { path: "edit/:materialTypeID?", element: <MaterialTypePage /> }
  ],
};

export default routes;
